export enum RoleType {
  ADMIN = 0,
  DELIVERY = 1,
  CLIENTSERVICE = 2,
  SALES = 3,
  CUSTOMER = 4,
  INTERN = 5
}
